import React, { useState } from 'react';
import ProductPricingManagerWorkspace from './ProductPricingManagerWorkspace';
import { usePricingConfig } from './hooks/usePricingConfig';
import { useDraftWorkflow } from './hooks/useDraftWorkflow';

function ProductPricingManagerPage() {
    const [activeTab, setActiveTab] = useState('overview');
    const pricingConfig = usePricingConfig();
    const draftWorkflow = useDraftWorkflow({
        draftConfig: pricingConfig.draftConfig,
        draftStatus: pricingConfig.draftStatus,
        loadConfig: pricingConfig.loadConfig
    });

    return (
        <ProductPricingManagerWorkspace
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            pricingConfig={pricingConfig}
            draftWorkflow={draftWorkflow}
        />
    );
}

export default ProductPricingManagerPage;
